<div class="overlay">
  <img src="assets/images/icon-loader.gif" class="loading-style"/>
</div>

